"use strict";
var import_vitest = require("vitest");
var import_getRouteInfo = require("./getRouteInfo");
(0, import_vitest.describe)("getRouteInfoFromState", function() {
  var state = {
    routes: [
      {
        name: "dev",
        path: "/dev#stack",
        params: {
          "#": "stack"
        }
      }
    ]
  };
  (0, import_vitest.it)("drops the hash from pathname and segments", function() {
    var info = (0, import_getRouteInfo.getRouteInfoFromState)(function(_state, asPath) {
      return {
        path: asPath ? "/(site)/dev#stack" : "/dev#stack",
        params: {
          "#": "stack"
        }
      };
    }, state);
    (0, import_vitest.expect)(info.pathname).toBe("/dev");
    (0, import_vitest.expect)(info.segments).toEqual([
      "(site)",
      "dev"
    ]);
    (0, import_vitest.expect)(info.unstable_globalHref).toBe("/dev#stack");
  });
  (0, import_vitest.it)("drops the query and the hash together", function() {
    var info = (0, import_getRouteInfo.getRouteInfoFromState)(function() {
      return {
        path: "/dev?x=1#stack",
        params: {
          x: "1",
          "#": "stack"
        }
      };
    }, state);
    (0, import_vitest.expect)(info.pathname).toBe("/dev");
    (0, import_vitest.expect)(info.segments).toEqual([
      "dev"
    ]);
  });
});
//# sourceMappingURL=getRouteInfo.test.js.map
